<div fxLayout="column" fxLayoutAlign="center center" class="dashboard-container">
  <div fxLayout="column" fxLayoutAlign="center">
    <div fxLayout="column" fxLayout.gt-xs="row wrap" fxLayoutAlign="center" fxLayoutAlign.gt-xs="start"
      *ngIf="currentYearTxnCatGroupsLoaded === true">
      <app-balance-all-accounts-stat class="stat-card"></app-balance-all-accounts-stat>
      <app-income-stat class="stat-card"></app-income-stat>
      <app-expenses-stat class="stat-card"></app-expenses-stat>
      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>{{sumTxnCurrent | currency}}</mat-card-title>
          <mat-card-subtitle>Expenses this month</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="trending-content">
            <span class="trend-value" [ngClass]="getIconColourDownIsGood(sumTxnState)">{{sumPercentDelta | percent:
              '1.2-2'}}</span>
            <mat-icon class="trend-icon" [ngClass]="getIconColourDownIsGood(sumTxnState)" aria-hidden="false"
              aria-label="Increasing trend icon" [fontIcon]="getIcon(sumTxnState)"></mat-icon>
            since last month
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>{{avgTxnCurrent | currency}}</mat-card-title>
          <mat-card-subtitle>Average Expense</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="trending-content">
            <span class="trend-value" [ngClass]="getIconColourDownIsGood(avgTxnState)">{{avgPercentDelta | percent:
              '1.2-2'}}</span>
            <mat-icon class="trend-icon" [ngClass]="getIconColourDownIsGood(avgTxnState)" aria-hidden="false"
              aria-label="Increasing trend icon" [fontIcon]="getIcon(avgTxnState)"></mat-icon>
            since last month
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>{{countTxnCurrent}}</mat-card-title>
          <mat-card-subtitle>Number of Expenses</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="trending-content">
            <span class="trend-value" [ngClass]="getIconColourDownIsGood(countTxnState)">{{countPercentDelta | percent:
              '1.2-2'}}</span>
            <mat-icon class="trend-icon" [ngClass]="getIconColourDownIsGood(countTxnState)" aria-hidden="false"
              aria-label="Increasing trend icon" [fontIcon]="getIcon(countTxnState)"></mat-icon>
            since last month
          </div>
        </mat-card-content>
      </mat-card>
      <!-- <mat-card class="stat-card" fxHide fxShow.gt-xs>
        <mat-card-header>
          <mat-card-title>{{minTxnCurrent | currency}}</mat-card-title>
          <mat-card-subtitle>Smallest Expense</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="trending-content">
            <span class="trend-value" [ngClass]="getIconColourDownIsGood(minTxnState)">{{minPercentDelta | percent:
              '1.2-2'}}</span>
            <mat-icon class="trend-icon" [ngClass]="getIconColourDownIsGood(minTxnState)" aria-hidden="false"
              aria-label="Increasing trend icon" [fontIcon]="getIcon(minTxnState)"></mat-icon>
            since last month
          </div>
        </mat-card-content>
      </mat-card> -->
      <mat-card class="stat-card" fxHide fxShow.gt-xs>
        <mat-card-header>
          <mat-card-title>{{maxTxnCurrent | currency}}</mat-card-title>
          <mat-card-subtitle>Largest Expense</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="trending-content">
            <span class="trend-value" [ngClass]="getIconColourDownIsGood(maxTxnState)">{{maxPercentDelta | percent:
              '1.2-2'}}</span>
            <mat-icon class="trend-icon" [ngClass]="getIconColourDownIsGood(maxTxnState)" aria-hidden="false"
              aria-label="Increasing trend icon" [fontIcon]="getIcon(maxTxnState)"></mat-icon>
            since last month
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div fxLayout="column" fxLayout.gt-xs="row wrap" fxLayoutAlign="center" fxLayoutAlign.gt-xs="start">
      <app-spend-by-day-bar-chart class="spending-by-day-card"></app-spend-by-day-bar-chart>
    </div>
    <div fxLayout="column" fxLayout.gt-xs="row wrap" fxLayoutAlign="center" fxLayoutAlign.gt-xs="start">
      <app-income-and-expenses-line-chart class="spending-habbits-card"></app-income-and-expenses-line-chart>
      <app-daily-balance-all-accounts-line-chart class="bank-balance-ytd-card">
      </app-daily-balance-all-accounts-line-chart>
      <app-accounts-list class="spending-habbits-card"></app-accounts-list>
    </div>
    <div fxLayout="column" fxLayout.gt-xs="row nowrap" fxLayoutAlign="center" fxLayoutAlign.gt-xs="start">
      <app-txn-cat-groups-stats-table class="spending-stats-table-card"></app-txn-cat-groups-stats-table>
      <app-txn-categories-stats-table class="spending-stats-table-card"></app-txn-categories-stats-table>

    </div>
  </div>
  <app-fab-menu [buttons]="fabButtons"></app-fab-menu>
</div>